import { render, staticRenderFns } from "./quote-file.vue?vue&type=template&id=968eac60&"
import script from "./quote-file.js?vue&type=script&lang=js&"
export * from "./quote-file.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports